import { types } from 'mobx-state-tree'
import { crudSideBar } from '../../../utils/types/enums'

/**
 * Add Editable model if it doesn't have it.
 * @param Model
 * @param defaultValue
 * @returns {IModelType<ModelPropertiesDeclarationToProperties<{draftModel: IMaybeNull<IModelType<ModelProperties, unknown, _CustomJoin<unknown, unknown>, _CustomJoin<unknown, unknown>>>, sideBarScreen: IMaybeNull<ISimpleType<UnionStringArray<(string)[]>>>}>, {setSideBar(*): void, showCreateAccount(): void, showViewSideBar(): void, cancelViewSideBar(): void, cancelCreateAccount(): void, showEditSideBar(*=): void, unsetSideBar(*): void, cancelEditSideBar(): void}, _NotCustomized, _NotCustomized>}
 */
export const crudSideBarStore = (Model, defaultValue = {}) =>
  types
    .model({})
    .volatile((self) => ({
      draftModel: types.optional(Model, () => Model.create(defaultValue)),
      sideBarScreen: null,
      isSending: false,
      refreshTable: 0,
      isShowConfirmation: false,
      showDelete: false,
      showDeleteModal: false,
      previousSidebar: '',
      isViewAfterReload: false,
    }))
    .actions((self) => ({
      resetRefreshTable: () => (self.refreshTable += 1),
      refreshAndViewSidebar: () => {
        self.resetRefreshTable()
        self.setIsViewAfterReload(true)
      },
      createDefaultDraftModel: () =>
        (self.draftModel = Model.create(defaultValue)),
      setSideBar: (screen) => (self.sideBarScreen = screen),
      setPreviousSidebar: (screen) => (self.previousSidebar = screen),
      unsetSideBar: (screen) => {
        if (self.sideBarScreen === screen) {
          self.sideBarScreen = null
        }
      },
      showDeleteSideBar: () => (self.showDelete = true),
      cancelDeleteSideBar: () => (self.showDelete = false),
      cancelAnySideBar: () => (self.sideBarScreen = null),
      showCreateSideBar(extraFn = () => {}) {
        self.cancelDeleteSideBar()
        self.createDefaultDraftModel()
        extraFn()
        self.setSideBar(crudSideBar.create)
      },
      cancelCreateSideBar: () => {
        self.unsetSideBar(crudSideBar.create)
      },
      setDraftModel: (model) => (self.draftModel = Model.create(model)),
      showAccountDeleteModal: (model) => {
        self.showDeleteModal = true
        self.setDraftModel(model)
      },
      closeAccountDeleteModal: () => {
        self.showDeleteModal = false
      },
      showEditSideBar(model) {
        self.cancelDeleteSideBar()
        if (model.house_credit_info?.ein_ssn) {
          model.setValue('house_credit_info', {
            ...model.house_credit_info,
            ein_ssn: '',
          })
        }
        self.setSideBar(crudSideBar.edit)
        self.setDraftModel(model)
      },
      cancelEditSideBar: () => self.unsetSideBar(crudSideBar.edit),
      showViewSideBar(model) {
        self.cancelDeleteSideBar()
        self.setSideBar(crudSideBar.view)
        self.setDraftModel(model)
      },
      showAddBillingContacts() {
        self.setPreviousSidebar(self.sideBarScreen)
        self.setSideBar(crudSideBar.addContact)
      },
      showAddSalesRepSideBar() {
        self.setPreviousSidebar(self.sideBarScreen)
        self.setSideBar(crudSideBar.addSalesRep)
      },
      cancelViewSideBar: () => {
        self.unsetSideBar(crudSideBar.view)
        self.setIsViewAfterReload(false)
      },
      closeAddContactSidebar: (customer) => {
        self.setSideBar(self.previousSidebar)
        const contacts = customer.contacts.filter((c) => !c.error && c.id)
        !self.isCreate && customer.setValue('contacts', contacts)
      },
      closeAddSalesRep: () => {
        self.setSideBar(self.previousSidebar)
      },
      startSending: () => (self.isSending = true),
      stopSending: () => (self.isSending = false),
      showConfirmation: () => (self.isShowConfirmation = true),
      cancelConfirmation: () => (self.isShowConfirmation = false),
      setIsViewAfterReload: (value) => (self.isViewAfterReload = value),
    }))
    .views((self) => ({
      get isCreate() {
        return self.sideBarScreen === crudSideBar.create
      },
      get isView() {
        return self.sideBarScreen === crudSideBar.view
      },
      get isEdit() {
        return self.sideBarScreen === crudSideBar.edit
      },
      get isDelete() {
        return self.showDelete
      },
      get isDelete() {
        return self.showDelete
      },
      get isAddContact() {
        return self.sideBarScreen === crudSideBar.addContact
      },
      get isAddSalesRep() {
        return self.sideBarScreen === crudSideBar.addSalesRep
      },
      get isAccountDelete() {
        return self.showDeleteModal
      },
    }))
